import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
    >
      <div className="sm:w-48 lg:w-56 flex-shrink-0">
        <div className="aspect-[16/9] sm:aspect-[4/3] rounded-md overflow-hidden">
          <img
            src={article.thumbnail}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-3 leading-relaxed">
          {article.summary}
        </p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
          <span>{article.author}</span>
          <span className="text-foreground-300">|</span>
          <span>{article.publishDate}</span>
          <span className="text-foreground-300">|</span>
          <span>{article.readTime}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {article.tags.map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}